"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueSnapshotsApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _urlExtractors = require("../util/urlExtractors");
const IssueSnapshotsApi = exports.IssueSnapshotsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    create: (issueId, urn, hasMarkups) => api.set("issues/".concat(issueId, "/snapshots"), {
      urn,
      hasMarkups
    })
  };
}, {
  invalidateByQueryKeys: url => {
    const issueId = (0, _urlExtractors.extractIssueId)(url);
    return [["issues", issueId]];
  }
});
//# sourceMappingURL=IssueSnapshotsApi.js.map